export var MuiButtonGroupOverrides = {
  defaultProps: {
    color: 'secondary',
    variant: 'contained'
  },
  styleOverrides: {
    root: {
      borderRadius: 9999,
      textTransform: 'none'
    }
  }
};